<template>
  <!--
    描述：菜品管理-菜品编辑-高级设置
  -->
  <div class="buy-set-content pl16 pr16">
    <el-form-item id="idD39aGz" :label="$t('口味')">
      <el-input id="id6Xvdg1" v-model="translations[activeName].form.model.taste" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item id="idNkZrFm" :label="$t('菜品卖点')">
      <el-input id="idqWWjfX" v-model="translations[activeName].form.model.selling_point" class="max-w460" type="textarea"></el-input>
      <mi-free-time>
        <el-button id="id8EApwh" @click="onSellingPoint" size="small" type="warning" :loading="selling_point_loading">{{$t('换一换')}}</el-button>
      </mi-free-time>
    </el-form-item>
    <el-form-item :label="$t('特色分类')">
      <el-radio-group v-model="translations[activeName].form.model.special_id">
        <el-radio :label="0">{{$t('无')}}</el-radio>
        <el-radio :label="item.category_id" v-for="(item,index) in translations[activeName].form.special" :key="index">{{item.name}}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item id="c794d1" class="uEXwDSa" :label="$t('配料')">
      <div id="idhhQjkh">
        <el-button id="id8sjR97" @click="addItem">{{$t('添加项')}}</el-button>
        <el-row id="idfszXiq">
          <el-col id="idfqh68V" v-for="item in translations[activeName].form.model.ingredient" class="uiNJkJ4" :span="6" :key="item.id">
            <el-input id="idGiAMPz" v-model="item.ingredient_name" class="uBgpnls uBuIHG1" :disabled="item.ingredient_id > 0 ? true : false"></el-input>
            <el-button id="idOSzPuv" @click="deleteItem(item.ingredient_name)" class="uFZHTog" icon="el-icon-close"></el-button>
          </el-col>
        </el-row>
      </div>
    </el-form-item>
    <div class="common-form ">{{$t('其他设置')}}</div>
    <el-form-item v-if="translations[activeName].form.model.product_status!=40" :label="$t('菜品状态')">
      <el-radio-group  v-model="translations[activeName].form.model.product_status">
        <el-radio :label="10">{{$t('上架')}}</el-radio>
        <el-radio :label="20">{{$t('下架')}}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item :label="$t('初始销量')">
      <el-input type="number" min="0" v-model="translations[activeName].form.model.sales_initial" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('菜品排序')" >
      <el-input type="number" min="0" v-model="translations[activeName].form.model.product_sort" class="max-w460"></el-input>
    </el-form-item>
    <el-form-item :label="$t('限购数量')">
      <el-input type="number" min="0" v-model="translations[activeName].form.model.limit_num" class="max-w460"></el-input>
      <div class="gray9">{{$t('每个会员购买的最大数量，0为不限购')}}</div>
    </el-form-item>
    <div class="common-form">{{$t('菜品属性')}}</div>
    <div>
      <div class="p-0-30 mb18">
        <div class="d-s-c">{{$t('菜品属性')}}: <div class="blue ml30" @click="addAttr">{{$t('添加属性')}}+</div></div>
      </div>
      <!--多规格表格-->
      <div class="mb18 p-0-30" v-for="(item,index) in translations[activeName].form.model.product_attr" :key="index" v-if="translations[activeName].form.model.product_attr.length>0">
        <div class="d-c-c mb16">
          <div style="width: 100px;" class="ml40"><span class="red">*</span>{{$t('属性名称')}}：</div>
          <div class="flex-1 ml40"><span class="red">*</span>{{$t('属性值')}}({{$t('至少填写两个')}})</div>
        </div>
        <div class="d-c-s">
          <div class="d-c-c">
            <el-button class='mr16 mb20' size="mini" icon="el-icon-delete" circle
                       @click="delIndex(index)"></el-button>
            <div style="width: 100px;">
              <el-form-item label-width="0" :rules="[{ required: true, message: ' ' }]"
                            :prop="'model.product_attr.'+index+'.attribute_name'">
                <el-autocomplete class="inline-input" size="medium" v-model="item.attribute_name"
                                 :fetch-suggestions="queryAttrSearch" :placeholder="$t('如:温度')"></el-autocomplete>
              </el-form-item>
            </div>
          </div>
          <div class="flex-1 d-s-s" style="flex-wrap: wrap;">
            <div v-for="(aitem,aindex) in item.attribute_value" :key="aindex" class="ml20 mb20">
              <el-form-item label-width="0" style="margin-bottom: 0;" :rules="[{ required: true, message: ' ' }]"
                            :prop="'model.product_attr.'+index+'.attribute_value.'+aindex">
                <el-autocomplete style="width: 100px;" size="medium" v-model="item.attribute_value[aindex]"
                                 :fetch-suggestions="(queryString,cb)=>querySearch2(queryString,cb,index)" :placeholder="$t('请选择')">
                </el-autocomplete>
                <el-button v-if="aindex == item.attribute_value.length - 1" class="ml10" size="mini"
                           icon="el-icon-plus" circle @click="addAttIndex(index)"></el-button>
                <el-button class='ml10' size="mini" icon="el-icon-delete" v-if="aindex>1" circle
                           @click="delAttIndex(index,aindex)"></el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <div class="p-0-30 mb18">
        <div class="d-s-c ">{{$t('菜品加料')}}: <div class="blue ml30" @click="addIngredients">{{$t('添加加料')}}+</div>
        </div>
      </div>
      <!--多规格表格-->
      <div class="p-0-30 mb18" v-for="(item,index) in translations[activeName].form.model.product_feed" :key="index">
        <div class="d-c-c mb16">
          <div style="width: 100px;"><span class="red">*</span>{{$t('加料名称')}}：</div>
          <div class="flex-1 ml20"><span class="red">*</span>{{$t('价格')}}</div>
        </div>
        <div class="d-s-c ml20" style="margin-left: 80px">
          <div>
            <el-form-item label="" style="margin-bottom: 0;width: 100px;" label-width="0">
              <el-autocomplete class="inline-input" v-model="item.feed_name" :placeholder="$t('如:杯型')" :fetch-suggestions="queryFeedSearch"></el-autocomplete>
            </el-form-item>
          </div>
          <div class="d-s-c ml20">
            <div>
                <el-form-item label="" style="margin-bottom: 0;"  label-width="0">
                <el-input type="number" style="width: 100px;" size="medium" v-model="item.price" placeholder="">
                </el-input> <span class="ml10">€</span><el-button size="mini" icon="el-icon-delete" circle @click="deleteIngredients(index)" style="margin-left: 20px;margin-top: 10px"></el-button>
              </el-form-item>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="common-form" v-if="$route.query.scene!= 'edit'">{{$t('菜品同步')}}</div>
    <el-form-item :label="$t('同步至店内')" v-if="$route.query.scene!= 'edit'">
      <el-radio-group v-model="translations[activeName].form.sync">
        <el-radio :label="1">{{$t('是')}}</el-radio>
        <el-radio :label="0">{{$t('否')}}</el-radio>
      </el-radio-group>
    </el-form-item>
  </div>
</template>
<script>
  import PorductApi from '@/api/product.js';
  export default {
    components:{
    },
    props:{
      activeName:{
        type:String,
        default:'chinese'
      },
    },
    inject: ['translations'],
    data() {
      return {
        selling_point_loading:false,
        getTagLoading: false,
      };
    },
    created() {
    },
    methods: {
      addIngredients() {
        if(this.translations[this.activeName].form.model.product_feed==''){
          this.translations[this.activeName].form.model.product_feed=[]
        }
        this.translations[this.activeName].form.model.product_feed.push({
          feed_name: '',
          price: ''
        })
      },
      deleteIngredients(n){
        this.translations[this.activeName].form.model.product_feed.splice(n,1)
      },
      queryFeedSearch(queryString, cb) {
        let self = this;
        if (self.restaurants.length == 0) {
          self.translations[this.activeName].form.feed.forEach((item, index) => {
            self.restaurants.push({
              value: item.feed_name
            })
          })
        }
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        };
      },

      addAttr() {
        if (this.translations[this.activeName].form.model.product_attr == '') {
          this.translations[this.activeName].form.model.product_attr = []
        }
        this.translations[this.activeName].form.model.product_attr.push({
          attribute_name: '',
          attribute_value: ['', '']
        })
      },
      queryAttrSearch(queryString, cb) {
        let self = this;
        if (self.restaurants.length == 0) {
          self.translations[this.activeName].form.attribute.forEach((item, index) => {
            self.restaurants.push({
              value: item.attribute_name
            })
          })
        }
        var restaurants = this.restaurants;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // 调用 callback 返回建议列表的数据
        cb(results);
      },
      querySearch2(queryString, cb, n) {
        let self = this;
        let list = [];
        let name = self.translations[this.activeName].form.model.product_attr[n].attribute_name;
        if (self.restaurants.length != 0 && name) {
          self.translations[this.activeName].form.attribute.forEach((item, index) => {
            if (item.attribute_name == name) {
              list = item.attribute_value;
              return
            }
          })
        }
        if (list.length > 0) {
          self.restaurants2 = [];
          list.forEach(item => {
            self.restaurants2.push({
              value: item
            })
          })
        }

        var results = this.restaurants2;
        cb(results);
      },

      addAttIndex(n) {
        this.translations[this.activeName].form.model.product_attr[n].attribute_value.push('')
      },
      delAttIndex(n, i) {
        this.translations[this.activeName].form.model.product_attr[n].attribute_value.splice(i, 1);
      },
      delIndex(n) {
        this.translations[this.activeName].form.model.product_attr.splice(n, 1);
      },

      addItem() {
        this.translations[this.activeName].form.model.ingredient.push({
          app_id : this.translations[this.activeName].form.model.app_id,
          product_id : this.translations[this.activeName].form.model.product_id,
          ingredient_id: 0,
          ingredient_name: '',
          sort:1
        });
      },
      deleteItem(_text) {
        const indexToRemove = this.translations[this.activeName].form.model.ingredient.findIndex(item => item.ingredient_name === _text);
        if (indexToRemove !== -1) {
          this.translations[this.activeName].form.model.ingredient.splice(indexToRemove, 1);
        }
      },
      //菜品卖点换一换
      onSellingPoint(){
        let self = this;
        let mainLanguage = localStorage.getItem("mainLanguage")
        if (mainLanguage == this.activeName){
          self.selling_point_loading = true;
          PorductApi.dishInformation_featrue(self.translations[mainLanguage].form.model.product_name,mainLanguage, {}, true).then(res => {
            self.selling_point_loading = false;
            //菜品卖点
            self.translations[mainLanguage].form.model.selling_point = res.data.response;
          }).catch(error => {
            self.selling_point_loading = false;
          });
        }else{
          alert(self.$t("请在主语言界面上进行操作"));
          this.$emit('active-name-changed', mainLanguage);
        }
      },
    }
  };
</script>

<style lang="scss" scoped>
.d-c-s {
  display: flex;
  justify-content: center;
  align-items: flex-start;
}
.d-s-c{
  color: #606266;
  font-size: 12px;
}
.d-c-c{
  color: #606266;
  font-size: 12px;
  margin-left: 80px;
}

.mb20 {
  margin-bottom: 20px;
}

.ml40 {
  margin-left: 42px;
}

.mt16{
  margin-left: 80px;
}
.mr16 {
  margin-right: 16px;
}
</style>



// WEBPACK FOOTER //
// src/views/buildstore/goods/takeaway/product/part/Adset.vue